export const POSITION_TO_ALLOCATE_TO_ADS_PLACEMENTS = 40;
export const NUM_OF_ADS_THREE_ROWS = 12;
